
import { SatellitalImage } from '../../../../../features/typescript/satellital/satellital_images';
import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import Button from '../../../../core/components/Generics/Button.vue';
import Combobox from '../../../../core/components/Generics/Combobox/Combobox.vue'
import ColorQuantitySelector from '../../combos/ColorQuantitySelector.vue';
import { formatDate } from '../../../../../features/core/utils/date-handlers';
import { ComboSelectedOption } from '../../../../../features/core/components/Generics/Combobox/Combobox';
import { showInfoSnackbar, showHighCloudyConfirmDialog } from '../../../../../features/helpers/alerts-popups';
import { getZonificationCloudyMessage } from '../../../../../features/item_with_sinisters/helpers/high-cloudy-confirm-messages';
import HighCloudyImageBadge from '../../satellital/HighCloudyImageBadge.vue';

@Component({
  components: { 
    Button, 
    Combobox,
    ColorQuantitySelector,
    HighCloudyImageBadge,
  },
})
export default class ModalZonification extends Vue {
  @Prop({default(){return []}}) bandImages: SatellitalImage[];
  @Prop({default: null}) selectedImage: SatellitalImage;
  @Prop({ default: null }) zonifiedDate!: string | null;
  @Prop({ default: 3 }) zonesLength!: number;
  
  modalTitle: string = 'Generar Zonificación';
  visible: boolean = true;

  selectedInitialDate: ComboSelectedOption = null;
  selectedInitialDateRv: boolean = false;
  scale: ComboSelectedOption | null = null;

  openComboboxCount: number = 0;

  get hasPreviewImage(): boolean {
    return this.selectedInitialDate !== null && !!this.selectedInitialDate['png_url'];
  }

  get allowDropdownOverflow(): boolean {
    return this.openComboboxCount > 0 || !this.hasPreviewImage;
  }

  onComboboxOpen() {
    this.openComboboxCount++;
  }

  onComboboxClose() {
    if (this.openComboboxCount > 0) {
      this.openComboboxCount--;
    }
  }

  get formattedBandImages(){
    if(this.bandImages.length == 0) return []

    return this.bandImages.map((image: SatellitalImage) => {
      return {
        id: image.id,
        date: image.date,
        value: formatDate(image.date, false, true),
        png_url: image.png_url,
        high_cloudy_image: image.high_cloudy_image,
      }
    })
  }

  async emitSave(){
    if(this.selectedInitialDate === null){
      showInfoSnackbar('Debe seleccionar una fecha');
      return;
    }
    if(this.scale === null){
      showInfoSnackbar('Debe seleccionar la cantidad de colores');
      return;
    }
    if (this.selectedInitialDate !== null && this.selectedInitialDate['high_cloudy_image'] === true) {
      const confirmed = await showHighCloudyConfirmDialog(getZonificationCloudyMessage());
      if (!confirmed) return;
    }
    this.$emit('save', {
      satellital_image_id: this.selectedInitialDate['id'],
      scale: this.scale.id
    });
  }

  mounted(){
    this.preselectZonesLength();

    if(this.zonifiedDate !== null){
      this.preselectFromZonifiedDate();
    } else if(this.selectedImage !== null){
      this.preselectFromSelectedImage();
    }
  }

  preselectZonesLength(){
    if(this.zonesLength > 0){
      this.scale = { id: this.zonesLength, value: this.zonesLength.toString() };
    }
  }

  @Watch('selectedImage')
  onSelectedImageChange(){  
    if(this.zonifiedDate !== null && this.selectedInitialDate !== null) return;

    if(this.selectedImage !== null){
      this.preselectFromSelectedImage();
    } else {
      this.selectedInitialDate = null;
    }
  }

  preselectFromZonifiedDate(){
    if(this.zonifiedDate === null) return;
    const found = this.formattedBandImages.find((img) => img.date === this.zonifiedDate);
    if(found){
      this.selectedInitialDate = found;
    }
  }

  preselectFromSelectedImage(){
    if(this.selectedImage === null) return;

    const found = this.formattedBandImages.find((img) => img.id === this.selectedImage.id);
    if(found){
      this.selectedInitialDate = found;
    }
  }

  @Emit()
  closeModal() {}
}
